class adminPermissionsService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
  }

  getOrgHierarchy(customerId) {
    const url = `${this.config.apiRoot}/customers/${customerId}/orgs/hierarchy?flattened=true`;
    return this.httpDim.get(url, {});
  }

  getPurchasingAccounts(orgXid) {
    const url = `${this.config.apiRoot}/customers/${orgXid}/purchasingAccounts`;
    return this.httpDim.get(url, {});
  }

  getPurchasingAccountsByCustomerId(customerId) {
    const url = `${this.config.apiRoot}/userAccount/access/customer/${customerId}`;
    return this.httpDim.get(url, {});
  }

addORremoveAccessAccounts(customerId, userId, payload) {
    const url = `${this.config.apiRoot}/userAccount/access/customer/${customerId}/user/${userId}/addOrRemove`;
    return this.httpDim.post(url, payload);
  }

  getAdministratorsAccounts(customerId, userId) {
    const url = `${this.config.apiRoot}/userAccount/access/customer/${customerId}/user/${userId}`;
    return this.httpDim.get(url, {});
  }
}

adminPermissionsService.$inject = ['httpDim', 'config'];

export default adminPermissionsService;



// WEBPACK FOOTER //
// ./app/components/adminPermissions/adminPermissions.service.js